export default __webpack_public_path__ + "static/HDR-how-hometown-works-icon-3-6f937b2292467537225c7138f9df5e2c.png";